import { Component, Inject } from '@angular/core';
import { MasterService } from '../../core/services/master.service';
import { SignalService } from '../../core/services/signal.service';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  standalone: true
})
export class FooterComponent {
  
  readonly s_full = Inject(SignalService).full;
  
  constructor(private _svcmaster: MasterService, private _svcsignal: SignalService) 
  {
    this.s_full = this._svcsignal.full;
  }

  navigate(p_destiny:string):void {
    this._svcmaster.navigate(p_destiny);
  }

}
